import { webClient } from "@shared/apis"

export default {
  post: (scheduleId: string | undefined | number) =>
    webClient.post(`/call_counsels`, {
      scheduleId,
    }),
}
